import React from 'react'
import DashboardSectionCard from '@components/pages/Dashboard/DashboardSectionCard.component'
import { useFinanceProductionByProcedure } from '@hooks/dashboard/useFinanceProductionByProcedure'
import {
  isDashboardSectionPending,
  shouldShowDashboardSectionEmpty,
} from '@utils/dashboardSectionEmpty.util'
import { ProductionByProcedureChart } from './ProductionByProcedureChart.component'

type ProductionByProcedureCardProps = {
  titleHref: string
  data: ReturnType<typeof useFinanceProductionByProcedure>
}

export function ProductionByProcedureCard({
  titleHref,
  data,
}: ProductionByProcedureCardProps): React.ReactElement {
  const isEmpty = shouldShowDashboardSectionEmpty(data.loading, data.hasData)
  const pending = isDashboardSectionPending(data.loading, data.hasPayload)

  return (
    <DashboardSectionCard
      title="Production by procedure"
      titleHref={titleHref}
      className="dashboard-finance-production-procedure-card"
      loading={pending}
      skeleton={{ block: 'chart' }}
      isEmpty={isEmpty}
    >
      <ProductionByProcedureChart
        data={data.chartConfig.data}
        axis={{
          yDomain: data.chartConfig.yDomain,
          yTicks: data.chartConfig.yTicks,
        }}
        categoryColors={data.categoryColors}
        orientation="vertical"
      />
    </DashboardSectionCard>
  )
}
